import { twMerge } from "tailwind-merge";
import { MdxRenderer } from "@shared/ui/MdxRenderer";
import { Article } from "../../support.types";
import { MdxRendererTableOfContents } from "@shared/ui/MdxRendererTableOfContents";

export type Props = {
  article: Article;
  className?: string;
  children?: React.ReactNode;
  isTableOfContentsVisible?: boolean;
};

export function StaticPage({
  article,
  className,
  children,
  isTableOfContentsVisible = false,
}: Props) {
  return (
    <div
      className={twMerge(
        "flex flex-col flex-1 w-full max-w-xl justify-between relative overflow-x-hidden",
        className
      )}
    >
      {isTableOfContentsVisible && (
        <MdxRendererTableOfContents content={article.content || ""} />
      )}
      <MdxRenderer content={article.content || ""} />
      {children}
    </div>
  );
}

export default StaticPage;
